// extracted by mini-css-extract-plugin
module.exports = {"container":"_1IEdOsgOqatoLT3c6KA7MG","groupsList":"AnYvkLiomYSikXWWYJoo6"};